import { useRequest } from '~/repositories'

/** Fetches the authenticated user's profile (`/me` endpoint). */
export const getMe = () => {
	return useRequest('get', `/v1/user/me/`, {})
}

/** Saves or updates the player's onboarding profile (frequency, favourite lottery, lucky number). */
export const postProfile = (payload: any) => {
	return useRequest('post', `/v1/player/profile/`, payload)
}

/** Marks the onboarding flow as skipped for the current user. */
export const postSkipOnboarding = (payload: any) => {
	return useRequest('post', `/v1/user/skip-onboarding/`, payload)
}

export default {
	getMe,
	postProfile,
	postSkipOnboarding,
}
